import React, { useState, useEffect, useRef, useCallback } from "react";
import leftBottomSvg from "../../assets/images/home/svg/formLeftBottom.svg";
import rightTopSvg from "../../assets/images/home/svg/formRightTop.svg";
import closeIcon from "../../assets/images/home/svg/close.svg";
import arrowIcon from "../../assets/images/home/svg/arrow.svg";
import editSvg from "../../assets/images/home/svg/edit.svg";
import backArrowIcon from "../../assets/images/home/svg/back-arrow.svg";
import calendarIcon from "../../assets/images/home/svg/calendar.svg";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { sendOtpThunk, submitFormThunk, verifyOtpThunk } from "./reducer/thunk";
import SnackbarComponent from "../../components/SnackbarComponent";
import BackdropComponent from "../../components/BackdropComponent";
import {
  adultAge,
  childAge,
  decrypt,
  encrypt,
  formatDateDDMMYYYY,
  isSafeNonUrl,
} from "../../utils/common-functions";
import { SARVAH_EMAIL } from "../../utils/constants";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

function HeroSectionForm() {
  const dispatch = useDispatch();

  const [showAlert, setShowAlert] = useState({
    message: "",
    type: "",
    color: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    pincode: "",
    agree: true,
    port: "no",
  });
  const [leadId, setLeadId] = useState("");
  const [latestDetails, setLatestDetails] = useState({
    callCenterName: "",
    latestMedium: "",
    latestCampaign: "",
    leadId: "",
    latestSource: "",
  });
  const [errors, setErrors] = useState({});
  const [isVerified, setIsVerified] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showTermsAndConditionsModal, setShowTermsAndConditionsModal] =
    useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const otpInputs = useRef([]);
  const [step, setStep] = useState(1);
  const [adultCount, setAdultCount] = useState(0);
  const [childCount, setChildCount] = useState(0);
  const [showAdultTooltip, setShowAdultTooltip] = useState(false);
  const [showChildTooltip, setShowChildTooltip] = useState(false);
  const adultTooltipRef = useRef(null);
  const childTooltipRef = useRef(null);
  const [adultTooltipHeight, setAdultTooltipHeight] = useState(0);
  const [childTooltipHeight, setChildTooltipHeight] = useState(0);
  const adultTooltipContentRef = useRef(null);
  const childTooltipContentRef = useRef(null);
  const [childDetails, setChildDetails] = useState([]);
  const [adultDetails, setAdultDetails] = useState([]);
  const [validateAdult, setValidateAdult] = useState([]);
  const [validateChild, setValidateChild] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);

  const sendOtpData = useSelector((state) => state.sarvah.sendOtp);
  const verifyOtpData = useSelector((state) => state.sarvah.verifyOtp);
  const submitFormData = useSelector((state) => state.sarvah.submitForm);

  const {
    status: sendOtpDataStatus,
    data: sendOtpDataDetails,
    error: sendOtpDataError,
  } = sendOtpData;
  const {
    status: verifyOtpDataStatus,
    data: verifyOtpDataDetails,
    error: verifyOtpDataError,
  } = verifyOtpData;
  const {
    status: submitFormDataStatus,
    data: submitFormDataDetails,
    error: submitFormDataError,
  } = submitFormData;

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }
    const token = await executeRecaptcha("mchiLogin");
    // Do whatever you want with the token
    setCaptchaToken(token);
    return token;
  }, [executeRecaptcha]);

  // You can use useEffect to trigger the verification as soon as the component being loaded
  React.useEffect(() => {
    handleReCaptchaVerify();
    // console.log("captchaToken", captchaToken);
  }, [handleReCaptchaVerify, captchaToken === null]);

  useEffect(() => {
    if (sendOtpDataStatus === "succeeded") {
      //since API returns true
      if (sendOtpDataDetails?.sendotp === true) {
        //code to show success alert and remove the data
        setLeadId(sendOtpDataDetails?.leadid);
        setLatestDetails({
          callCenterName: sendOtpDataDetails?.callCenterName,
          latestMedium: sendOtpDataDetails?.latest_medium,
          latestCampaign: sendOtpDataDetails?.latest_campaign,
          leadId: sendOtpDataDetails?.leadid,
          latestSource: sendOtpDataDetails?.latest_Source,
        });
        setShowAlert({
          message: "OTP sent successfully",
          type: "success",
          color: "success",
        });
        setTimer(60);
      } else {
        //if api returns false code to show error alert
        setShowAlert({
          message: "An error occured! Please try again",
          type: "error",
          color: "error",
        });
      }
    } else if (sendOtpDataStatus === "failed") {
      setShowAlert({
        message: "Failed to send OTP. Please try again",
        type: "error",
        color: "error",
      });
    }
  }, [sendOtpDataStatus]);

  useEffect(() => {
    if (submitFormDataStatus === "succeeded") {
      //since API returns true
      if (submitFormDataDetails === "Form submitted successfully") {
        //code to show success alert and remove the data
        // setShowAlert({
        //   message: "Form submitted successfully",
        //   type: "success",
        //   color: "success",
        // });
        //generate encrypted JSON data logic here
        generateJsonData();
      } else {
        //if api returns false code to show error alert
        setShowAlert({
          message: "An error occured! Please try again",
          type: "error",
          color: "error",
        });
      }
    } else if (submitFormDataStatus === "failed") {
      setShowAlert({
        message: "Failed to save the form. Please try again",
        type: "error",
        color: "error",
      });
    }
  }, [submitFormDataStatus]);

  useEffect(() => {
    if (verifyOtpDataStatus === "succeeded") {
      if (verifyOtpDataDetails?.verify) {
        setShowAlert({
          message: "OTP verified successfully",
          type: "success",
          color: "success",
        });
        setShowModal(false);
        setIsVerified(true);
        setOtp(["", "", "", ""]);

        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source") || "DIRECT_ODC";
        const medium = urlParams.get("medium") || "HPBanner";
        const campaign = urlParams.get("campaign") || "DEFCMP03";

        if (
          isSafeNonUrl(encodeURIComponent(leadId)) &&
          isSafeNonUrl(encodeURIComponent(source)) &&
          isSafeNonUrl(encodeURIComponent(medium)) &&
          isSafeNonUrl(encodeURIComponent(campaign))
        ) {
          const url = `${process.env.REACT_APP_ONLINE_JOURNEY}/getinitial-details/quick-quote/manipalcigna-sarvah?q=${leadId}&source=${source}&medium=${medium}&campaign=${campaign}`;
          console.log("final URL", url);
          window.open(url, "_self");
        }

        // setFormData({ name: "", mobile: "", pincode: "", agree: false });
        // setStep(2); // Move to the next step after verification
      } else {
        //if api returns false code to show error alert

        setShowAlert({
          message: "An error occured! Please try again",
          type: "error",
          color: "error",
        });
      }
    } else if (verifyOtpDataStatus === "failed") {
      setShowAlert({
        message: "Failed to verify OTP. Please try again",
        type: "error",
        color: "error",
      });
    }
  }, [verifyOtpDataStatus]);

  useEffect(() => {
    let interval;
    if (showModal && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showModal, timer]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        adultTooltipRef.current &&
        !adultTooltipRef.current.contains(event.target)
      ) {
        setShowAdultTooltip(false);
        setIsEditing(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        childTooltipRef.current &&
        !childTooltipRef.current.contains(event.target)
      ) {
        setShowChildTooltip(false);
        setIsEditing(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (adultCount === 0) {
      setShowAdultTooltip(false);
    }
  }, [adultCount]);

  useEffect(() => {
    if (childCount === 0) {
      setShowChildTooltip(false);
    }
  }, [childCount]);

  useEffect(() => {
    if (adultTooltipContentRef.current) {
      setAdultTooltipHeight(adultTooltipContentRef.current.offsetHeight);
    }
  }, [adultCount]);

  useEffect(() => {
    if (childTooltipContentRef.current) {
      console.log(
        "Child tooltip content height:",
        childTooltipContentRef.current.offsetHeight
      );
      setChildTooltipHeight(childTooltipContentRef.current.offsetHeight);
    } else {
      console.log("Child tooltip content ref is null");
    }
  }, [childCount, childDetails]);

  useEffect(() => {
    // Update childDetails when childCount changes
    setChildDetails((prevDetails) => {
      const newDetails = [...prevDetails];
      while (newDetails.length < childCount) {
        newDetails.push({ dob: "", gender: "" });
      }
      return newDetails.slice(0, childCount);
    });
  }, [childCount]);
  useEffect(() => {
    // Update childDetails when childCount changes
    setAdultDetails((prevDetails) => {
      const newDetails = [...prevDetails];
      while (newDetails.length < adultCount) {
        newDetails.push({
          dob: "",
          gender: "",
        });
      }
      return newDetails.slice(0, adultCount);
    });
  }, [adultCount]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "mobile") {
      // Allow only numbers and limit to 10 digits
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else if (name === "pincode") {
      // Allow only numbers, limit to 6 digits, and ensure it doesn't start with 0
      const numericValue = value.replace(/\D/g, "");
      if (
        numericValue.length === 0 ||
        (numericValue.length <= 6 && numericValue[0] !== "0")
      ) {
        setFormData({
          ...formData,
          [name]: numericValue,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.name) tempErrors.name = "Name is required";
    if (!formData.mobile) {
      tempErrors.mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
      tempErrors.mobile = "Please enter a valid 10-digit mobile number";
    }
    if (!formData.pincode) tempErrors.pincode = "Pincode is required";
    if (!formData.agree)
      tempErrors.agree = "You must agree to the Terms and Conditions";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleOtpChange = (index, value) => {
    // Only allow numeric input
    const numericValue = value.replace(/[^0-9]/g, "");

    const newOtp = [...otp];
    newOtp[index] = numericValue;
    setOtp(newOtp);

    if (numericValue && index < 3) {
      otpInputs.current[index + 1].focus();
    }
  };

  const sendOtp = async () => {
    //* Generating captcha token
    const token = await handleReCaptchaVerify();
    //* Code for sending OTP to user
    let reqObj = {
      name: formData?.name ? formData.name : "",
      mobileNumber: formData?.mobile ? formData.mobile : "",
      selectInsuranceType: null,
      pincode: formData?.pincode ? formData.pincode : "",
      emailAddress: null,
      productName: "manipalcigna-sarvah",
      planName: "manipalcigna-sarvah",
      source: new URLSearchParams(window.location.search).get("source")
        ? new URLSearchParams(window.location.search).get("source")
        : "",
      medium: new URLSearchParams(window.location.search).get("medium")
        ? new URLSearchParams(window.location.search).get("medium")
        : "",
      campaign: new URLSearchParams(window.location.search).get("campaign")
        ? new URLSearchParams(window.location.search).get("campaign")
        : "",
      captcha: token,
      pageName: "product",
    };

    dispatch(sendOtpThunk(reqObj));
  };

  const getGender = (val) => {
    if (val.toLowerCase() === "male") {
      return "MALE";
    } else if (val.toLowerCase() === "female") {
      return "FEMALE";
    } else if (val.toLowerCase() === "other") {
      return "OTHER";
    } else {
      return "GENDER";
    }
  };

  const generateJsonData = () => {
    let childAdultArr = [];
    for (let i = 0; i < 8; i++) {
      if (adultDetails && adultDetails.length >= i + 1) {
        // console.log("adultDetails", i, adultDetails[i]);
        let tmp = {};
        tmp[`GENDER`] = getGender(adultDetails[i]?.gender);
        tmp[`DOB`] = adultDetails[i]?.dob;
        tmp[`Adult`] = "YES";
        tmp[`AnnualIncome`] = "";
        tmp[`RelationShip`] = "";
        childAdultArr.push(tmp);
      } else if (
        childDetails &&
        childDetails.length + adultDetails.length >= i + 1
      ) {
        // console.log(
        //   "childDetails",
        //   i,
        //   adultDetails.length,
        //   childDetails[Math.abs(adultDetails.length - i)]
        // );
        let ctmp = {};
        ctmp[`GENDER`] = getGender(
          childDetails[Math.abs(adultDetails.length - i)]?.gender
        );
        ctmp[`DOB`] = childDetails[Math.abs(adultDetails.length - i)]?.dob;

        ctmp[`Adult`] = "NO";
        ctmp[`AnnualIncome`] = "";
        ctmp[`RelationShip`] = "";
        childAdultArr.push(ctmp);
      }
    }

    let jsonData = { leadId: leadId || "" };
    let encData = encrypt(
      process.env.REACT_APP_CRYPTO_KEY,
      JSON.stringify(jsonData)
    );
    console.log("encrypted data ", encData);
    let decData = decrypt(process.env.REACT_APP_CRYPTO_KEY, encData);
    console.log("dec Data", decData);

    window.location.replace(
      // `${process.env.REACT_APP_UAT_REDIRECT_URL}${encData}`
      `https://online.manipalcigna.com/sarvah/quick-quote/your-quote?q=${encData}`
    );
  };

  const formSubmit = () => {
    let req1 = {
      name: formData?.name ? formData.name : "",
      pinCode: formData?.pincode ? formData.pincode : "",
      emailAddress: SARVAH_EMAIL,
      mobileNumber: formData?.mobile ? formData.mobile : "",
      adultCount: adultCount,
      childCount: childCount,
      peopleCount: adultCount + childCount,
      source: "DIRECT_ODC",
      medium: "HOMEQQ",
      campaign: "DEFCMP03",
      portability: formData?.port === "yes" ? "Y" : "N",
      leadid: leadId ? leadId : "",
      latest_source: latestDetails?.latestSource,
      latest_medium: latestDetails?.latestMedium,
      latest_campaign: latestDetails?.latestCampaign,
      callCenterName: latestDetails?.callCenterName,
    };
    let req2 = {};
    for (let i = 0; i < 8; i++) {
      if (adultDetails && adultDetails.length >= i + 1) {
        req2[`gender${i + 1}`] = adultDetails[i]?.gender.toUpperCase();
        req2[`dob${i + 1}`] = adultDetails[i]?.dob;
        req2[`adultStatus${i + 1}`] = "YES";
      } else if (
        childDetails &&
        childDetails.length + adultDetails.length >= i + 1
      ) {
        // console.log("childDetails", i, childDetails[Math.abs(adultDetails.length - i + 1)]);
        req2[`gender${i + 1}`] =
          childDetails[Math.abs(adultDetails.length - i)]?.gender.toUpperCase();

        req2[`dob${i + 1}`] =
          childDetails[Math.abs(adultDetails.length - i)]?.dob;

        req2[`adultStatus${i + 1}`] = "NO";
      } else {
        req2[`gender${i + 1}`] = "";
        req2[`dob${i + 1}`] = "";
        req2[`adultStatus${i + 1}`] = "";
      }
    }
    let mergedReqBody = { ...req1, ...req2 };
    dispatch(submitFormThunk(mergedReqBody));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    switch (step) {
      case 1:
        if (validate()) {
          //1.	Send OTP API call here
          sendOtp();
          setShowModal(true);
        }
        break;
      case 2:
        // Handle submission for step 2
        if (validateStep2()) {
          // Perform any necessary actions for step 2
          setStep(3);
        }
        break;
      case 3:
        // Handle final submission
        if (validateStep3()) {
          // Perform final submission actions
          // Reset form or navigate to a new page
          setStep(1);
          setIsVerified(false);
        }
        break;
      default:
        console.warn("Invalid step");
    }
  };

  // Add new validation functions for each step
  const validateStep2 = () => {
    if (adultCount === 0 || childCount === 0) {
      // setShowAdultTooltip(true);
      // setShowChildTooltip(true);
      return false;
    }
    // Add validation logic for step 2
    // return true; // Replace with actual validation
  };

  const validateStep3 = () => {
    // Add validation logic for step 3
    return true; // Replace with actual validation
  };

  const handleVerifyOtp = () => {
    const enteredOtp = otp.join("");
    let reqObj = {
      mobileNumber: formData?.mobile ? formData.mobile : "",
      otp: enteredOtp ? enteredOtp : "",
      leadId: leadId,
      //statically coded product name
      productName: "manipalcigna-sarvah",
    };
    dispatch(verifyOtpThunk(reqObj));
  };

  const handleEditMobile = () => {
    setShowModal(false);
  };

  const incrementAdult = () => {
    if (adultCount + childCount < 8) {
      setAdultCount(adultCount + 1);
    }
  };

  const decrementAdult = () => {
    if (adultCount > 0) {
      setAdultCount(adultCount - 1);
      // Reset DOB and Gender for the removed adult
      setAdultDetails((prevDetails) => {
        const newDetails = [...prevDetails];
        newDetails.pop(); // Remove the last adult's details
        return newDetails;
      });
      setValidateAdult((prevDetails) => {
        const newDetails = [...prevDetails];
        newDetails.pop(); // Remove the last adult's details
        return newDetails;
      });
    }
  };

  const handleClose = () => {
    setShowAlert({
      message: "",
      type: "",
      color: "",
    });
  };

  const incrementChild = () => {
    if (adultCount + childCount < 8) {
      setChildCount(childCount + 1);
    }
  };

  const decrementChild = () => {
    if (childCount > 0) {
      setChildCount(childCount - 1);
      // Reset DOB and Gender for the removed child
      setChildDetails((prevDetails) => {
        const newDetails = [...prevDetails];
        newDetails.pop(); // Remove the last child's details
        return newDetails;
      });
      setValidateChild((prevDetails) => {
        const newDetails = [...prevDetails];
        newDetails.pop(); // Remove the last child's details
        return newDetails;
      });
    }
  };

  const handleAdultIncrement = () => {
    incrementAdult();
    setShowAdultTooltip(true);
  };

  const handleChildIncrement = () => {
    incrementChild();
    setShowChildTooltip(true);
  };

  const handleAdultDecrement = () => {
    decrementAdult();
    if (adultCount > 1) {
      setShowAdultTooltip(true);
    } else {
      setShowAdultTooltip(false);
    }
  };

  const handleChildDecrement = () => {
    decrementChild();
    if (childCount > 1) {
      setShowChildTooltip(true);
    } else {
      setShowChildTooltip(false);
    }
  };

  const handleChildDetailsChange = (index, field, value) => {
    setChildDetails((prevDetails) => {
      const newDetails = [...prevDetails];
      newDetails[index] = { ...newDetails[index], [field]: value };
      return newDetails;
    });
  };

  const handleAdultDateChange = (index, e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

    if (value.length > 8) value = value.slice(0, 8);

    // Add slashes
    if (value.length > 4) {
      value =
        value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4);
    } else if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2);
    }
    setAdultDetails((prevDetails) => {
      const newDetails = [...prevDetails];
      newDetails[index] = {
        ...newDetails[index],
        dob: value,
      };

      return newDetails;
    });

    setValidateAdult((prevDetails) => {
      const newDetails = [...prevDetails];
      newDetails[index] = {
        ...newDetails[index],
        adult: adultAge(value),
      };
      return newDetails;
    });
  };

  const handleAdultGenderChange = (index, value) => {
    setAdultDetails((prevDetails) => {
      const newDetails = [...prevDetails];
      newDetails[index] = { ...newDetails[index], gender: value };
      return newDetails;
    });
  };

  const handleEditDetails = (type) => {
    // setIsEditing(!isEditing);
    if (type === "adult") {
      setShowAdultTooltip(!showAdultTooltip);
    } else {
      setShowChildTooltip(!showChildTooltip);
    }
  };

  const handleChildDateChange = (index, e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

    if (value.length > 8) value = value.slice(0, 8);

    // Add slashes
    if (value.length > 4) {
      value =
        value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4);
    } else if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2);
    }
    setChildDetails((prevDetails) => {
      const newDetails = [...prevDetails];
      newDetails[index] = { ...newDetails[index], dob: value };
      return newDetails;
    });
    setValidateChild((prevDetails) => {
      const newDetails = [...prevDetails];
      newDetails[index] = {
        ...newDetails[index],
        child: childAge(value),
      };
      return newDetails;
    });
  };

  // Add this new function to check if all fields are filled
  const areAllFieldsFilled = () => {
    // Check if port selection is made
    if (!formData.port) return false;

    // Check if at least one adult or child is selected
    if (adultCount === 0 && childCount === 0) return false;

    // Check adult details
    for (let i = 0; i < adultCount; i++) {
      if (!adultDetails[i] || !adultDetails[i].dob || !adultDetails[i].gender)
        return false;
    }

    //add adult and child age validations here to disable or enable view plan button
    if (validateAdult.some((user) => user.adult === false)) {
      return false;
    }

    if (validateChild.some((user) => user.child === false)) {
      return false;
    }
    // Check child details
    for (let i = 0; i < childCount; i++) {
      if (!childDetails[i] || !childDetails[i].dob || !childDetails[i].gender)
        return false;
    }

    return true;
  };

  // const handleDateInputClick = (id) => {
  //   document.getElementById(id).showPicker();
  // };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <form
            id="heroSectionForm"
            onSubmit={handleSubmit}
            // onSubmit={(e) => handleSubmit(values)}
            className="flex flex-col bg-[#F7F7F7] rounded-[32px] p-6 h-auto lg:h-[486px] lg:w-[424px]"
          >
            <label className="text-[#181818] text-base leading-[18.4px] pb-2">
              Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className={`border border-black border-opacity-30 rounded-xl px-4 py-2 bg-transparent lg:w-[360px] ${
                errors.name ? "mb-2" : "mb-10"
              }`}
            />
            {errors.name && (
              <span className="text-xs leading-[13.4px] text-[#FF7E7E] mb-2">
                {errors.name}
              </span>
            )}

            <label className="text-[#181818] text-base leading-[18.4px] pb-2">
              Mobile Number
            </label>
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              className={`border rounded-xl border-black border-opacity-30 px-4 py-2 bg-transparent ${
                errors.mobile ? "mb-2" : "mb-10"
              }`}
            />
            {errors.mobile && (
              <span className="text-xs leading-[13.4px] text-[#FF7E7E] mb-2">
                {errors.mobile}
              </span>
            )}

            <label className="text-[#181818] text-base leading-[18.4px] pb-2">
              Pincode
            </label>
            <input
              type="tel"
              name="pincode"
              placeholder="Pincode"
              value={formData.pincode}
              onChange={handleChange}
              maxLength="6"
              className={`border rounded-xl px-4 border-black border-opacity-30 py-2 bg-transparent ${
                errors.pincode ? "mb-2" : "mb-10"
              }`}
            />
            {errors.pincode && (
              <span className="text-xs leading-[13.4px] text-[#FF7E7E] mb-6">
                {errors.pincode}
              </span>
            )}

            <label className="flex items-center mb-2">
              <input
                type="checkbox"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
                className="mr-3 custom-checkbox"
              />
              <p className="opacity-60 text-sm">
                I agree to the{" "}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setShowTermsAndConditionsModal(true);
                  }}
                  className="underline"
                >
                  Terms and Conditions
                </button>
              </p>
            </label>
            {errors.agree && (
              <span className="text-xs  leading-[23px] text-[#FF7E7E] mb-2">
                {errors.agree}
              </span>
            )}
            <button
              type="submit"
              className="bg-[#FB7C2F] text-xl leading-[23px] font-normal rounded-xl text-white py-[9px] px-4"
            >
              Get Quote
            </button>
          </form>
        );
      case 2:
        return (
          <div className="flex flex-col bg-[#F7F7F7] gap-20 rounded-[32px] p-8 h-auto lg:h-[536px] lg:w-[424px]">
            <form
              onSubmit={handleSubmit}
              className="flex flex-col relative justify-between bg-[#F7F7F7] rounded-[32px] h-full"
            >
              <div className="flex flex-col">
                <label className="text-[#181818] text-base leading-[24px] pb-4">
                  Are you looking to port/migrate your health insurance?
                </label>
                <div className="flex mb-10">
                  <button
                    type="button"
                    onClick={() =>
                      handleChange({ target: { name: "port", value: "yes" } })
                    }
                    className={`flex-1 text-xl py-2 px-4 rounded-tl-xl rounded-bl-xl border border-r-0 ${
                      formData.port === "yes"
                        ? "bg-[#F8B78F] text-black"
                        : "bg-white text-[#181818] text-opacity-[54%]"
                    }`}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      handleChange({ target: { name: "port", value: "no" } })
                    }
                    className={`flex-1 text-xl py-3 px-4 rounded-tr-xl rounded-br-xl border ${
                      formData.port === "no"
                        ? "bg-[#F8B78F] text-black"
                        : "bg-white text-[#181818] text-opacity-[54%]"
                    }`}
                  >
                    No
                  </button>
                </div>

                <label className="text-[#181818] text-base leading-[18.4px] pb-4">
                  Select family members you wish to cover.
                </label>
                <div className="flex flex-row gap-8 w-full">
                  <div className="flex flex-col gap-4 w-full">
                    <label className="text-[#181818] text-sm font-bold leading-[24px]">
                      Adult
                    </label>
                    <div className="flex flex-row justify-between border py-2 px-4 rounded-xl border-[#181818] border-opacity-30">
                      <button
                        type="button"
                        onClick={handleAdultDecrement}
                        className={`text-[#FB7C2F] text-lg font-bold leading-[24px] ${
                          adultCount === 0
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={adultCount === 0}
                      >
                        -
                      </button>
                      <p className="text-[#181818] text-2xl font-bold leading-[32px]">
                        {adultCount}
                      </p>
                      <button
                        type="button"
                        onClick={handleAdultIncrement}
                        className={`text-[#FB7C2F] text-lg font-bold leading-[24px] ${
                          adultCount + childCount >= 8
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={adultCount + childCount >= 8}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="flex flex-col gap-4 w-full">
                    <label className="text-[#181818] text-sm font-bold leading-[24px]">
                      Child
                    </label>
                    <div className="flex flex-row justify-between border py-2 px-4 rounded-xl border-[#181818] border-opacity-30">
                      <button
                        type="button"
                        onClick={handleChildDecrement}
                        className={`text-[#FB7C2F] text-lg font-bold leading-[24px] ${
                          childCount === 0
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={childCount === 0}
                      >
                        -
                      </button>
                      <p className="text-[#181818] text-2xl font-bold leading-[32px]">
                        {childCount}
                      </p>
                      <button
                        type="button"
                        onClick={handleChildIncrement}
                        className={`text-[#FB7C2F] text-lg font-bold leading-[24px] ${
                          adultCount + childCount >= 8
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={adultCount + childCount >= 8}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Display counts and edit button when not editing */}
              {(adultCount > 0 || childCount > 0) && (
                <div className="flex flex-row w-full justify-between gap-8 mt-5">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => handleEditDetails("adult")}
                    className="flex flex-row p-2 w-[50%] justify-between bg-white rounded-xl items-center"
                  >
                    <p className="flex flex-row gap-2 items-center text-sm leading-6 font-bold">
                      <span className="bg-[#F7F7F7] rounded-full px-2">
                        {adultCount}
                      </span>
                      <span className="">
                        Adult{adultCount !== 1 ? "s" : ""}
                      </span>
                    </p>
                    <button
                      onClick={() => handleEditDetails("adult")}
                      className=""
                    >
                      <img src={editSvg} alt="edit" />
                    </button>
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => handleEditDetails("child")}
                    className="flex flex-row p-2 w-[50%] justify-between bg-white rounded-xl items-center"
                  >
                    <p className="flex flex-row gap-2 items-center text-sm leading-6 font-bold">
                      <span className="bg-[#F7F7F7] rounded-full px-2">
                        {childCount}
                      </span>
                      <span className="">
                        {childCount !== 1 ? "Children" : "Child"}
                      </span>
                    </p>
                    <button
                      onClick={() => handleEditDetails("child")}
                      className=""
                    >
                      <img src={editSvg} alt="edit" />
                    </button>
                  </div>
                </div>
              )}

              {/* Adult tooltip */}
              {(showAdultTooltip || isEditing) && adultCount > 0 && (
                <div
                  ref={adultTooltipRef}
                  style={{
                    top: `88%`,
                    transition: "top 0.3s ease-out",
                  }}
                  className="absolute bg-white w-[310px] lg:w-[99%] border border-gray-200 rounded-lg shadow-lg p-4 z-10"
                >
                  <div className="flex gap-4 mb-2" style={{ color: "red" }}>
                    {validateAdult.some((user) => user.adult === false)
                      ? "Invalid Date: "
                      : ""}
                    {validateAdult?.map((val, i) => {
                      return val["adult"] ? "" : ` Adult ${i + 1}`;
                    })}
                  </div>
                  <div ref={adultTooltipContentRef}>
                    {[...Array(adultCount)].map((_, index) => (
                      <div key={index} className="flex flex-col gap-1">
                        <span>Adult {index + 1}</span>
                        <div className="flex gap-4 mb-2">
                          <div className="relative w-[50%]">
                            <div className="border rounded-xl w-full bg-white p-3 pr-10 flex items-center">
                              <input
                                type="text"
                                placeholder="DD/MM/YYYY"
                                value={adultDetails[index]?.dob || ""}
                                onChange={(e) =>
                                  handleAdultDateChange(index, e)
                                }
                                className="w-full bg-transparent placeholder:text-black outline-none"
                              />
                              <img
                                src={calendarIcon}
                                alt="Calendar"
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                onClick={() => {
                                  const dateInput = document.getElementById(
                                    `adult-date-${index}`
                                  );

                                  // If no date is selected, set the value to "1994-01-01"
                                  if (!dateInput.value) {
                                    dateInput.value = "1994-01-01";
                                  }
                                  dateInput.showPicker() || dateInput.focus();
                                }}
                              />
                            </div>
                            <input
                              id={`adult-date-${index}`}
                              type="date"
                              value={
                                adultDetails[index]?.dob
                                  ? adultDetails[index].dob
                                      .split("/")
                                      .reverse()
                                      .join("-")
                                  : ""
                              }
                              onChange={(e) => {
                                const date = new Date(e.target.value);
                                const formattedDate = `${date
                                  .getDate()
                                  .toString()
                                  .padStart(2, "0")}/${(date.getMonth() + 1)
                                  .toString()
                                  .padStart(2, "0")}/${date.getFullYear()}`;
                                handleAdultDateChange(index, {
                                  target: { value: formattedDate },
                                });
                              }}
                              className="absolute left-0 top-full mt-1 opacity-0"
                            />
                          </div>
                          <select
                            value={adultDetails[index]?.gender || ""}
                            onChange={(e) =>
                              handleAdultGenderChange(index, e.target.value)
                            }
                            className="border grow bg-white placeholder:text-black rounded-xl p-3 pr-8 appearance-none webkit-appearance-none bg-no-repeat bg-right"
                            style={{
                              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                              backgroundPosition: "right 0.75rem center",
                              backgroundSize: "12px",
                            }}
                          >
                            <option value="">Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                          </select>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Child tooltip */}
              {(showChildTooltip || isEditing) && childCount > 0 && (
                <div
                  ref={childTooltipRef}
                  style={{
                    top: `88%`,
                    transformOrigin: "top",
                    transition: "top 0.3s ease-out",
                  }}
                  className={`absolute bg-white w-[310px] lg:w-[99%] border border-gray-200 rounded-lg shadow-lg p-4 z-10`}
                >
                  <div ref={childTooltipContentRef}>
                    <div className="flex gap-4 mb-2" style={{ color: "red" }}>
                      {validateChild.some((user) => user.child === false)
                        ? "Invalid Date: "
                        : ""}
                      {validateChild?.map((val, i) => {
                        return val["child"] ? "" : ` Child ${i + 1}`;
                      })}
                    </div>
                    {childDetails.map((child, index) => (
                      <div key={index} className="flex flex-col gap-1 w-full">
                        <span>Child {index + 1}</span>
                        <div className="flex gap-4 mb-2">
                          <div className="relative w-[50%]">
                            <div className="border rounded-xl w-full bg-white p-3 pr-10 cursor-pointer flex items-center">
                              <input
                                type="text"
                                placeholder="DD/MM/YYYY"
                                value={childDetails[index]?.dob || ""}
                                onChange={(e) =>
                                  handleChildDateChange(index, e)
                                }
                                className="w-full bg-transparent placeholder:text-black outline-none"
                              />
                              <img
                                src={calendarIcon}
                                alt="Calendar"
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                onClick={() =>
                                  document
                                    .getElementById(`child-date-${index}`)
                                    .showPicker() ||
                                  document
                                    .getElementById(`child-date-${index}`)
                                    .focus()
                                }
                              />
                            </div>
                            <input
                              id={`child-date-${index}`}
                              type="date"
                              value={
                                childDetails[index]?.dob
                                  ? childDetails[index].dob
                                      .split("/")
                                      .reverse()
                                      .join("-")
                                  : ""
                              }
                              onChange={(e) => {
                                const date = new Date(e.target.value);
                                const formattedDate = `${date
                                  .getDate()
                                  .toString()
                                  .padStart(2, "0")}/${(date.getMonth() + 1)
                                  .toString()
                                  .padStart(2, "0")}/${date.getFullYear()}`;
                                handleChildDateChange(index, {
                                  target: { value: formattedDate },
                                });
                              }}
                              className="absolute left-0 top-full mt-1 opacity-0"
                            />
                          </div>
                          <select
                            value={childDetails[index]?.gender || ""}
                            onChange={(e) =>
                              handleChildDetailsChange(
                                index,
                                "gender",
                                e.target.value
                              )
                            }
                            className="border grow bg-white placeholder:text-black rounded-xl p-3 pr-8 appearance-none webkit-appearance-none bg-no-repeat bg-right"
                            style={{
                              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                              backgroundPosition: "right 0.75rem center",
                              backgroundSize: "12px",
                            }}
                          >
                            <option value="">Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                          </select>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </form>
            <div className="flex flex-row gap-4 w-full">
              <button
                onClick={() => setStep(1)}
                type="button"
                className="border border-[#FB7C2F] rounded-xl p-4"
              >
                <img src={backArrowIcon} alt="back" />
              </button>
              <button
                type="submit"
                onClick={() => {
                  //api call here
                  formSubmit();
                  // setStep(3);
                }}
                className={`text-xl leading-[23px] font-normal rounded-xl p-4 w-full ${
                  areAllFieldsFilled()
                    ? "bg-[#FB7C2F] text-white cursor-pointer"
                    : "bg-[#DDDDDD] cursor-not-allowed text-[#00000040]"
                }`}
                disabled={!areAllFieldsFilled()}
              >
                View Plans
              </button>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="flex flex-col bg-[#F7F7F7] rounded-[32px] p-8">
            <h2 className="text-2xl font-bold mb-4">Thank You!</h2>
            <p className="text-lg mb-4">
              Your information has been submitted successfully.
            </p>
            <p className="text-base mb-6">
              We'll get back to you shortly with your quote.
            </p>
            <button
              onClick={() => {
                setStep(1);
                setIsVerified(false);
                setFormData({
                  name: "",
                  mobile: "",
                  pincode: "",
                  agree: false,
                });
              }}
              className="bg-[#FB7C2F] text-xl leading-[23px] font-normal rounded-xl text-white py-[14px] px-4"
            >
              Submit Another Request
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="px-6 lg:px-0 lg:pr-[120px] lg:pt-[20px] relative">
      {renderStep()}
      <img
        src={leftBottomSvg}
        alt="leftBottom"
        className="hidden lg:block absolute bottom-[20%] -left-[13%]"
      />
      <img
        src={rightTopSvg}
        alt="rightTop"
        className="hidden lg:block absolute top-[12%] right-[12%]"
      />

      {showAlert.message !== "" && (
        <SnackbarComponent
          handleClick={handleClose}
          message={showAlert.message}
          type={showAlert.type}
          color={showAlert.color}
        />
      )}
      {verifyOtpDataStatus === "failed" && (
        <SnackbarComponent
          handleClick={handleClose}
          message={showAlert.message}
          type={showAlert.type}
          color={showAlert.color}
        />
      )}

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white p-6 lg:p-8 rounded-[24px] lg:rounded-[32px] relative w-fit flex flex-col gap-6">
            <h2 className="text-2xl font-bold">Enter OTP</h2>
            <div className="flex flex-col gap-4">
              <div className="flex gap-[1em] items-center">
                <p className="text-base">
                  Send to xxxxxxxx{formData.mobile.slice(-2)}
                </p>
                <button
                  onClick={handleEditMobile}
                  className="text-[#FB7C2F] text-base underline"
                >
                  Edit
                </button>
              </div>
              <div className="flex flex-col">
                <div className="flex gap-4 mb-4">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength="1"
                      autoFocus={index === 0 ? true : false}
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      ref={(el) => (otpInputs.current[index] = el)}
                      className="w-[60px] lg:w-[78px] h-[48px] text-center border rounded-xl"
                    />
                  ))}
                </div>
                <p className="text-right text-base">
                  <button
                    disabled={timer}
                    onClick={() => {
                      sendOtp();
                      setShowModal(true);
                      setTimer(60);
                    }}
                    style={{
                      color: timer !== 0 ? "" : "#0000EE",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Resend OTP
                  </button>
                  {timer ? (
                    <span className="font-bold" sx={{ pl: 1, pr: 1 }}>
                      in {timer} Seconds
                    </span>
                  ) : null}
                </p>
              </div>
            </div>
            <button
              onClick={handleVerifyOtp}
              className="bg-[#FB7C2F] text-xl flex items-center justify-between font-normal rounded-xl text-white py-[14px] px-4"
            >
              Verify OTP
              <img src={arrowIcon} alt="arrow" className="" />
            </button>
            <img
              src={closeIcon}
              alt="close"
              className="absolute top-5 right-5 cursor-pointer"
              onClick={() => {
                setShowModal(false);
                setOtp(["", "", "", ""]);
              }}
            />
          </div>
        </div>
      )}
      {showTermsAndConditionsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 ">
          <div className="bg-white p-6 m-4 lg:p-8 rounded-[24px] lg:rounded-[32px] relative w-fit flex flex-col gap-6">
            <h2 className="text-2xl font-bold">Disclaimer</h2>

            <div className="flex flex-colgap-4 mb-4">
              <div className="flex gap-4 mb-1">
                <p className="text-base  mb-1  lg:w-[424px]">
                  By submitting my details, I override my NDNC registration and
                  authorize ManipalCigna Health Insurance and its
                  representatives to contact me through call, RCS, Whatsapp or
                  E-mail. I further consent to share my information on
                  confidential basis with third parties for evaluating and
                  processing this proposal.
                </p>
              </div>
            </div>
            <img
              src={closeIcon}
              alt="close"
              className="absolute top-5 right-5 cursor-pointer"
              onClick={() => setShowTermsAndConditionsModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default HeroSectionForm;
